import { render } from "./MenuChildren.vue?vue&type=template&id=23cba40f"
import script from "./MenuChildren.vue?vue&type=script&lang=js"
export * from "./MenuChildren.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__